var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDegreeHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    fill: "none",
    viewBox: "0 0 25 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M3.477 11.916v3.382c0 .879.478 1.697 1.243 2.118l5.979 3.286a2.36 2.36 0 0 0 2.296 0l5.979-3.286a2.423 2.423 0 0 0 1.243-2.118v-3.382l-7.222 3.972a2.36 2.36 0 0 1-2.296 0l-7.222-3.972ZM10.699.289.619 5.825c-.825.458-.825 1.661 0 2.119l10.08 5.536a2.36 2.36 0 0 0 2.296 0l9.614-5.283v7.113c0 .662.538 1.204 1.195 1.204.658 0 1.196-.542 1.196-1.204V7.595c0-.446-.24-.843-.622-1.06L12.995.29a2.425 2.425 0 0 0-2.296 0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDegreeHat);
export default __webpack_public_path__ + "static/media/icon-degree-hat.54bd2a2a.svg";
export { ForwardRef as ReactComponent };